import { render, staticRenderFns } from "./app-space.vue?vue&type=template&id=48e98463&scoped=true"
import script from "./app-space.vue?vue&type=script&lang=js"
export * from "./app-space.vue?vue&type=script&lang=js"
import style0 from "./app-space.vue?vue&type=style&index=0&id=48e98463&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e98463",
  null
  
)

export default component.exports